<template>
  <div class="container page">
    <van-nav-bar
      :title="hasPayPassword ? $t('setting.change_money_pwd') : $t('setting.set_money_pwd')"
      class="nav-bar"
    >
      <template #left>
        <van-icon name="arrow-left" color="#fff" @click="back()" />
      </template>
    </van-nav-bar>
    <div class="wrapper">
      <div v-if="hasPayPassword" class="item">
        <p class="title">{{ $t('setting.old_money_pwd') }}</p>
        <pwd-box-input
          ref="oldInput"
          v-model="oldpw"
          @complete="focusRef('newInput')"
        />
      </div>

      <div class="item">
        <p class="title">
          {{ hasPayPassword ? $t('setting.new_money_pwd') : $t('setting.money_place') }}
        </p>
        <pwd-box-input
          ref="newInput"
          v-model="newpw"
          @complete="focusRef('confirmInput')"
        />
      </div>

      <div class="item">
        <p class="title">{{ $t('setting.money_again_place') }}</p>
        <pwd-box-input ref="confirmInput" v-model="confirmpw" />
      </div>

      <van-button class="sub-btn" type="default" @click="setPayPassword()">
        {{ $t('reservation.submit') }}
      </van-button>
    </div>
  </div>
</template>

<script>
import PwdBoxInput from '../../components/PwdBoxInput.vue';

export default {
  components: { PwdBoxInput },
  data() {
    return {
      oldpw: '',
      newpw: '',
      confirmpw: '',
      userInfo: {},
      hasPayPassword: false,
    };
  },
  methods: {
    back() {
      this.$router.go(-1);
    },
    focusRef(refName) {
      this.$nextTick(() => {
        const comp = this.$refs[refName];
        if (comp && comp.focusInput) {
          comp.focusInput();
        }
      });
    },
    focusFirst() {
      const name = this.hasPayPassword ? 'oldInput' : 'newInput';
      this.focusRef(name);
    },
    setPayPassword() {
      if (this.hasPayPassword && this.oldpw.length !== 6) {
        this.focusRef('oldInput');
        this.$toast(this.$t('setting.old_pwd_required'));
        return;
      }
      if (this.newpw.length !== 6) {
        this.focusRef('newInput');
        this.$toast(this.$t('setting.pwd_6_digits'));
        return;
      }
      if (this.confirmpw.length !== 6) {
        this.focusRef('confirmInput');
        this.$toast(this.$t('setting.pwd_6_digits'));
        return;
      }
      if (this.newpw !== this.confirmpw) {
        this.$toast(this.$t('setting.pwd_not_match'));
        return;
      }
      if (!/^\d{6}$/.test(this.newpw)) {
        this.$toast(this.$t('setting.pwd_must_digits'));
        return;
      }

      const requestData = this.hasPayPassword
        ? { old_paypassword: this.oldpw, paypassword: this.newpw }
        : { paypassword: this.newpw };

      this.$http({
        method: 'post',
        data: requestData,
        url: 'user_set_paypw',
      }).then((res) => {
        if (res.code === 200) {
          this.$toast(res.msg);
          const redirect = this.$route.query.redirect;
          if (redirect) {
            this.$router.replace({ path: redirect });
          } else {
            this.$router.replace({ path: '/Mine' });
          }
        } else {
          this.$toast(res.msg);
        }
      });
    },
    getUserInfo() {
      this.$http({
        method: 'get',
        url: 'user_info',
      }).then((res) => {
        if (res.code === 200) {
          this.userInfo = res.data;
          this.hasPayPassword = !!(res.data.paypassword && String(res.data.paypassword).length > 0);
          this.focusFirst();
        } else if (res.code === 401) {
          this.$toast(res.msg);
        }
      });
    },
  },
  created() {
    if (!localStorage.getItem('token')) {
      this.$router.push({ path: '/Login' });
    } else {
      this.getUserInfo();
    }
  },
};
</script>

<style lang="less" scoped>
@import '../../assets/css/base.css';

.nav-bar {
  background: #d63595 !important;
}
::v-deep .van-nav-bar {
  background: #d63595 !important;
}
::v-deep .van-nav-bar__title {
  color: #fff !important;
}

.container .wrapper {
  min-height: calc(100vh - 50px);
  padding: 0 16px 40px;
  background-color: #fff;
  box-sizing: border-box;
}

.container .wrapper .item .title {
  margin: 36px 0 20px;
  line-height: 1.4;
  font-size: 16px;
  font-weight: 500;
  color: #000;
  text-align: center;
}

.container .wrapper .sub-btn {
  display: block;
  margin: 48px auto 0;
  height: 48px;
  width: 80%;
  max-width: 320px;
  font-size: 16px;
  border-radius: 24px;
  color: #fff;
  border: none;
  background: #e8afbd;
}

.container .wrapper .sub-btn::v-deep.van-button--default {
  background: #e8afbd;
  border: none;
  color: #fff;
}
</style>
